import { State, Action, StateContext } from '@ngxs/store';
import { country, gender, RegisterStateModel, source, Step } from './register-state.model';
import { Injectable } from '@angular/core';
import {
  UpdateCurrentStep,
  UpdateEmailVerification,
  UpdateSetPassword,
  UpdatePersonalDetails,
  UpdateGenderSelection,
  UpdateDateOfBirth,
  UpdatePerviousCourseCompletionOn,
  UpdateCollegeStart,
  UpdateHearAboutUs,
  UpdateDestination,
  UpdateAcademicsPreferences,
  UpdateJourneyPreferences,
  UpdateTemporaryToken,
  UpdateDegreePreference,
  UpdateHomeCountry,
  UpdateIntendedMajor
} from './register-action';

@State<RegisterStateModel>({
  name: 'register',
  defaults: {
    emailVerification: {
      email: '',
      emailVerified: false
    },
    setPassword: {
      password: '',
      confirmPassword: ''
    },
    personalDetails: {
      name: ''
    },
    // genderSelection: {},
    // dateOfBirth: {
    //   bornOn: {
    //     day: '',
    //     month: '',
    //     year: ''
    //   }
    // },
    degreePreference: {
      degreePreference: undefined
    },
    // intendedMajor: {
    //   intendedMajor: ''
    // },
    // perviousCourseCompletionOn: {
    //   perviousCourseCompletionOn: ''
    // },
    // collegeStart: {
    //   collegeStartOn: ''
    // },
    hearAboutUs: {},
    // homeCountry: {},
    destination: {},
    academicsPreferences: {
      academics: [],
      costAndOutcomes: [],
      studentLife: []
    },
    journeyPreferences: {
      journey: []
    },
    currentStep: Step.emailVerification,
    temporaryToken: ''
  }
})
@Injectable()
export class RegisterState {

  @Action(UpdateCurrentStep)
  updateCurrentStep(ctx: StateContext<RegisterStateModel>, action: UpdateCurrentStep) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      currentStep: action.payload.step,
    });
  }

  @Action(UpdateEmailVerification)
  updateEmailVerification(ctx: StateContext<RegisterStateModel>, action: UpdateEmailVerification) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      emailVerification: {
        email: action.payload.email || state.emailVerification.email,
        emailVerified: action.payload.emailVerified
      }
    });
  }

  @Action(UpdateSetPassword)
  updateSetPassword(ctx: StateContext<RegisterStateModel>, action: UpdateSetPassword) {
    ctx.setState({
      ...ctx.getState(),
      setPassword: {
        password: action.payload.password,
        confirmPassword: action.payload.confirmPassword
      }
    });
  }

  @Action(UpdatePersonalDetails)
  updatePersonalDetails(ctx: StateContext<RegisterStateModel>, action: UpdatePersonalDetails) {
    ctx.setState({
      ...ctx.getState(),
      personalDetails: {
        name: action.payload.name
      }
    });
  }

  // @Action(UpdateGenderSelection)
  // updateGenderSelection(ctx: StateContext<RegisterStateModel>, action: UpdateGenderSelection) {
  //   ctx.setState({
  //     ...ctx.getState(),
  //     genderSelection: {
  //       gender: action.payload.gender
  //     }
  //   });
  // }

  // @Action(UpdateDateOfBirth)
  // updateDateOfBirth(ctx: StateContext<RegisterStateModel>, action: UpdateDateOfBirth) {
  //   ctx.setState({
  //     ...ctx.getState(),
  //     dateOfBirth: {
  //       bornOn: action.payload.bornOn
  //     }
  //   });
  // }

  @Action(UpdateDegreePreference)
  updateApplyingFor(ctx: StateContext<RegisterStateModel>, action: UpdateDegreePreference) {
    ctx.setState({
      ...ctx.getState(),
      degreePreference: {
        degreePreference: action.payload.degreePreference!
      }
    });
  }

  // @Action(UpdateIntendedMajor)
  // updateIntendedMajor(ctx: StateContext<RegisterStateModel>, action: UpdateIntendedMajor) {
  //   ctx.setState({
  //     ...ctx.getState(),
  //     intendedMajor: {
  //       intendedMajor: action.payload.intendedMajor
  //     }
  //   });
  // }


  // @Action(UpdatePerviousCourseCompletionOn)
  // updateGraduationDate(ctx: StateContext<RegisterStateModel>, action: UpdatePerviousCourseCompletionOn) {
  //   ctx.setState({
  //     ...ctx.getState(),
  //     perviousCourseCompletionOn: {
  //       perviousCourseCompletionOn: action.payload.perviousCourseCompletionOn
  //     }
  //   });
  // }

  // @Action(UpdateCollegeStart)
  // updateCollegeStart(ctx: StateContext<RegisterStateModel>, action: UpdateCollegeStart) {
  //   ctx.setState({
  //     ...ctx.getState(),
  //     collegeStart: {
  //       collegeStartOn: action.payload.collegeStartOn
  //     }
  //   });
  // }

  @Action(UpdateHearAboutUs)
  updateHearAboutUs(ctx: StateContext<RegisterStateModel>, action: UpdateHearAboutUs) {
    ctx.setState({
      ...ctx.getState(),
      hearAboutUs: {
        source: action.payload.hearabouts
      }
    });
  }

  // @Action(UpdateHomeCountry)
  // updateHomeCountry(ctx: StateContext<RegisterStateModel>, action: UpdateHomeCountry) {
  //   ctx.setState({
  //     ...ctx.getState(),
  //     homeCountry: {
  //       homeCountry: action.payload.homeCountry
  //     }
  //   });
  // }

  @Action(UpdateDestination)
  updateDestination(ctx: StateContext<RegisterStateModel>, action: UpdateDestination) {
    ctx.setState({
      ...ctx.getState(),
      destination: {
        destination: action.payload.destination
      }
    });
  }

  @Action(UpdateAcademicsPreferences)
  updateAcademicsPreferences(ctx: StateContext<RegisterStateModel>, action: UpdateAcademicsPreferences) {
    ctx.setState({
      ...ctx.getState(),
      academicsPreferences: {
        academics: action.payload.academics,
        costAndOutcomes: action.payload.costAndOutcomes,
        studentLife: action.payload.studentLife
      }
    });
  }

  @Action(UpdateJourneyPreferences)
  updateJourneyPreferences(ctx: StateContext<RegisterStateModel>, action: UpdateJourneyPreferences) {
    ctx.setState({
      ...ctx.getState(),
      journeyPreferences: {
        journey: action.payload.journey
      }
    });
  }

  @Action(UpdateTemporaryToken)
  updateTemporaryToken(ctx: StateContext<RegisterStateModel>, action: UpdateTemporaryToken) {
    ctx.setState({
      ...ctx.getState(),
      temporaryToken: action.payload.token
    });
  }
}
